const Form081SC = {
    stepName: {
        importantNotes: "重要事项",
        selectSchool: "学校类别",
        partA: "尚未成立法团校董会的学校",
        partB: "已成立法团校董会的学校",
        confirmation: "确认页面",
    },
    noteList: {
        note1: "注1：如该无薪假期最后一日之翌日为星期日或宪报公布之公众假期，则该星期日或宪报公布之公众假期将被视为无薪假期之延续。如该无薪假期最后一日之翌日为主要的学校假期，包括圣诞节假期、农历新年假期、复活节假期及暑假，其薪酬会于该教师向学校报到并复工当日起恢复。故此，该教师的无薪假期申请必须包括这些属于无薪假期延续的日子。",
        note2: "注2：须预先获有关的学校发展主任确认。",
        note3A: "注3：有关(a)至(d)项所列的无薪假期间因法例规定的责任而引致的开支，资助学校请参阅该学年「资助学校的营办开支整笔津贴(营办津贴)／扩大的营办开支整笔津贴(扩大的营办津贴)及综合家具及设备津贴」的通函，以及上载于教育局网页的营办津贴运用指引。",
        note3B: "注3：有关(a)至(d)项所列的无薪假期间因法例规定的责任而引致的开支，资助学校请参阅该学年「资助学校的营办开支整笔津贴(营办津贴)／扩大的营办开支整笔津贴(扩大的营办津贴)及综合家具及设备津贴」的通函，以及上载于教育局网页的扩大的营办津贴运用指引。",
        importantNotesStatement: "无薪假期申请表／批准通知书个人资料收集声明",
        part1Title: "收集个人资料的目的",
        importantNotesPurpose:
            "1.	你在本表格提供的个人资料，会供教育局用于以下一项或多项用途：",
        importantNotesA: "处理、核实及查证就无薪假期的申请／批准通知；",
        importantNotesB:
            "就上文(a)项所述申请／批准通知的处理、核实及查证，将个人资料与政府相关政策局／部门资料库进行核对；",
        importantNotesC:
            "将个人资料与教育局资料库进行核对，以核实／更新教育局的记录；",
        importantNotesD:
            "培训及发展，包括发出计划／活动邀请、处理发还课程费用申请、 评审提名、奖项和奖学金，以及监察达标进度；",
        importantNotesE:
            "处理及审核拨款／补助／津贴申请、发放拨款／补助／津贴，以及审计； ",
        importantNotesF: "编制统计资料、研究及政府刊物；以及",
        importantNotesG:
            "执行规则及规例[包括《教育条例》(香港法例第279章)及其附属法例(例如《教育规例》、《补助学校公积金规则》、《津贴学校公积金规则》)和《资助则例》]。",
        // importantNotesObligatory:
        //     "申请人必须在本表格上填写个人资料。申请人如不提供这些资料，申请的处理工作及结果或会受影响。",
        // importantNotesDisclosed:
        //     "本表格所搜集的个人资料，或会向其他获授权的政府决策局/部门/机构披露作上述用途。",
        // importantNotesRights:
        //     "根据《个人资料(私隐)条例》，第18和22条及附表1保障资料第6原则的规定，你有权要求查阅及改正你的个人资料。要求查阅的权利，包括要求提供本表格所载个人资料的副本，但须缴付费用。",
        // importantNotesConcern:
        //     "如欲查询有关本表格所蒐集的个人资料，包括要求查阅及改正资料事宜，需以书面方式向有关高级学校发展主任提出。",
        checked: "本人已检阅",
        part2: "2.	你必须按本表格的要求及于本局处理本表格的过程中提供个人资料。假如你没有提供该等个人资料，本局可能无法办理或继续处理有关申请／批准通知。",
        part3Title: "可获转移资料者",
        part3: "3.	你提供的个人资料会供教育局人员取阅。除此之外，本局亦可能会向下列各方或在下述情况转移或披露该等个人资料：",
        part3a: "政府其他政策局及部门，以用于上文第1段所述的用途；",
        part3b: "与本表格相关的学校，以用于上文第1段所述的用途；",
        part3c: "你曾就披露个人资料给予订明同意；以及",
        part3d: "根据适用于香港的法例或法庭命令授权或规定披露个人资料。",
        part4Title: "查阅个人资料",
        part4: '4.	你有权要求查阅及更正教育局所持有关于你的个人资料。如需查阅或更正个人资料，请以书面向有关高级学校发展主任提出，并寄交教育局网页(<a href="https://www.edb.gov.hk/en/contact-us/reo.html" target="_blank">https://www.edb.gov.hk/en/contact-us/reo.html</a>)所载区域教育服务处地址或电邮至<a href="mailto:edbinfo@edb.gov.hk">edbinfo@edb.gov.hk</a>。',
        and: "提交的：",
        confirmValid1:
            "相关证明文件并确认其有效。 [只适用于(a)项所列的假期类别]",
        confirmValid2:
            "相关证明文件并确认其有效，现随函夹附有关的证明文件以便贵局处理申请。此外，本人亦已通知",
        confirmValid2B:
            "相关证明文件并确认其有效。本人明白教育局或要求本校提供有关上述无薪假期申请的证明文件。此外，本人亦已通知",
        confirmValid3:
            "须于上述无薪假期最后一日之翌日向学校报到并复工，以便学校于其复工当日起恢复支付其薪酬。 [只适用于(b)至(e)项所列的假期类别]",
        declaration1: "{{addition}}",
        declaration1Option: {
            approval: "请批准{{name}}{{title}}在上述期间放取无薪假期并保留该员",
            open: "请批准保留{{name}}{{title}}",
        },
        declaration1Option2: {
            approval:
                "请批准 <b>{{name}}{{title}}</b> 在上述期间放取无薪假期并保留该员",
            open: "请批准保留 <b>{{name}}{{title}}</b>",
        },
        // declaration4: "在上述期间放取无薪假期，请批准保留该员在",
        declaration4: "在",
        declarationFrom: "",
        declarationFrom2: "上述期间放取无薪假期，请批准保留该员在",
        declarationTo: "至",
        declaration2:
            "(首尾两天包括在内)的公积金账户。该员的无薪假期将不会算作公积金供款的无间断年资。",
        declaration3A:
            "本人明白学校必须自行承担履行一切法例规定的责任，包括支付因教师放取无薪假期而可能引致的任何开支，例如法定假日的开支 ",
        declaration3B:
            "本人亦明白学校必须自行承担履行一切法例规定的责任，包括支付因教师放取无薪假期而可能引致的任何开支，例如法定假日的开支 ",
    },
    label: {
        msgList: {
            msg1: "致：",
            msg2: "区域教育服务处高级学校发展主任",
            msg3: "副本：",
            msg4: "财政科高级会计主任(公积金)",
            msg5: "第二副本：",
            msg6: "放取假期的学校",
            msg7: "",
            msg8: "先生/女士：",
            msg9A: "校长/教师",
            msg9B: "校长/教师",
            msg10: "无薪假期",
            msg11: "本校",
            msg12: "",
            msg13: "于",
            msg14: "申请放取无薪假期。",
            msg15: "本校已",
            msg16: "申请由",
            msg17: "至",
            msg18: "(首尾两天包括在内)",
            msg19: "由于",
            msg20: "天无薪假期，",
            msg21: "天无薪假期，其增薪日期",
            msg22: "至",
            msg23: "月一日。",
            msg24: "。",
        },
        schoolType: "请选择学校类别",
        date: "日期",
        SSDO: "高级学校发展主任",
        nameOfSchool: "学校名称",
        nameOf: "姓名",
        name: "姓名",
        headOrTeacher: "校长／教师",
        nameOfHeadOrTeacher: "校长／教师姓名",
        rank: "职系",
        rankWithBracket: "(职系)",
        textBeforeNoPayLeaveDay: "放取共",
        textAfterNoPayLeaveDay: "天的无薪假期，",
        note1: "注1",
        onGroundOf: "其申请理由是",
        sickOrMaternityOrSpecialTubLeave: "病假／产假／肺病特别假期",
        fullStop: "。",
        fullStop2: "。",
        comma: "，",
        studyLeave: "为参加与教育有关课程而放取的进修假期。(请注明)",
        courseName: "课程名称",
        organizingIns: "主办院校",
        healthLeave: "由有效的医生证明书证明因健康理由而需放取的假期。",
        redundantLeaveText1: "为解决",
        redundantLeaveText2: "因超额教师问题而放取的假期",
        note2: "注2",
        school: "本校／相同办学团体的学校",
        plsSpecifyNameOfOtherSchool: "(请注明该学校的名称",
        otherLeave: "因私人原因而放取的其他假期。",
        otherReason: "(请注明原因",
        reason: "原因",
        from: "由",
        ofMySchoolDated: "申请于",
        willBeAdjusted: "其增薪日期将调整至",
        toTakeNoPayLeaveOf: "放取共",
        notifyAsFollows: "放取无薪假期，现特通知如下。",
        hasBeenGiven: "批准",
        hasBeenGranted: "获准放取",
        note3: "注3",
        will: "将",
        unchange: "维持不变",
    },
    formContent: {
        schoolTypeOption: {
            PartA: "尚未成立法团校董会的学校",
            PartB: "已成立法团校董会的学校",
        },
        titleOption: {
            Mr: "先生",
            Ms: "女士",
        },
        appliedOrGrantedOption1: {
            applied: "接获",
            granted: "批准",
        },
        appliedOrGrantedOption2: {
            applied: "申请",
            granted: "获准放取",
        },
        headOrTeacherOption: {
            head: "校长",
            teacher: "教师",
        },
        leaveOption: {
            sickLeave: "病假",
            maternityLeave: "产假",
            specialTubLeave: "肺病特别假期",
        },
        mySchoolOrAnotherSchoolOption: {
            mySchool: "本校",
            anotherSchool: "相同办学团体的学校",
        },
        adjustedOption: {
            will: "将调整(如获批准)",
            is: "已调整",
        },

        monthOption: {
            1: "一",
            2: "二",
            3: "三",
            4: "四",
            5: "五",
            6: "六",
            7: "七",
            8: "八",
            9: "九",
            10: "十",
            11: "十一",
            12: "十二",
            na: "不适用",
        },
        SSDOOption: {
            e: "東区",
            i: "離島区",
            k: "觀塘区",
            kc: "九龍城区",
            kt: "葵青区",
            m: "中西区",
            n: "北区",
            s: "南区",
            sk: "西貢区",
            ssp: "深水埗区",
            st: "沙田区",
            tm: "屯門区",
            tp: "大埔区",
            tw: "荃灣区",
            w: "灣仔区",
            wts: "黃大仙区",
            y: "元朗区",
            ytm: "油尖旺区",
        },
        numberList: {
            a: "(a)",
            b: "(b)",
            c: "(c)",
            d: "(d)",
            e: "(e)",
        },
    },
    errorMsg: {
        option: "请选择最少一个申请理由",
    },
};
export default Form081SC;
